import type React from 'react';
import { UserIndexMap } from '@client/lib/auth';

/**
 * Builds an AntD Table column definition for a user field.
 */
export const buildUserItemColumn = (
	key: string,
	title: string,
	userIndex: UserIndexMap,
	userIds: Array<number | string>,
) => {
	const name = (id: number | string | null) => userIndex.get(Number(id))?.name ?? '';

	return {
		title,
		dataIndex: key,
		key,
		render: (id: number) => name(id),
		sorter: (a: Record<string, unknown>, b: Record<string, unknown>) => {
			const nameA = name(Number(a[key]));
			const nameB = name(Number(b[key]));

			return nameA.localeCompare(nameB);
		},
		filters: (userIds ?? [])
			.filter(Boolean)
			.map((id) => ({
				text: name(id),
				value: id,
			})),
		onFilter: (
			value: React.Key | boolean,
			record: Record<string, unknown>,
		) => Number(record[key]) === Number(value),
		width: key === 'fixedBy' ? 130 : 150,
	};
};
